// extracted by mini-css-extract-plugin
export var childPages = "ArticleTagList-module--childPages--lCkm+";
export var footer = "ArticleTagList-module--footer--kuiey";
export var siblingPages = "ArticleTagList-module--siblingPages--hzE2+";